import React from "react";

import "./_progress-bar.scss";

export const ProgressBar = ({
  progressPercent,
}: {
  progressPercent: number;
}) => {
  return (
    <div className="progress-bar">
      <span style={{ width: `${progressPercent}%` }}></span>
    </div>
  );
};
